import My from '../components/pages/My';
import { GetStaticProps } from 'next';

export default My;
export const getStaticProps: GetStaticProps = async () => ({
        props: {},
    });
